export const pagedDropdownI18NPl = {
    items: (first, last, total) => `${first}–${last} z ${total}`,
    page: (current, total) => `strona: ${current} / ${total}`,
};
